import SearchIconSvg from '../assets/search.svg';

export function SearchIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={SearchIconSvg} alt='search' />;
}
